import { IPagination } from '../types/pagination'
import { IDirectCostInvoice, IPositionPayment, IProjectInvoice } from '../views/project/types/invoice'
import { HttpClient } from './service'
import Urls from './urls'


export const AccountingApi = {
  getProjectInvoices(projectId: string | number, queryParams: Record<string, string>): Promise<IProjectInvoice[]> {
    return HttpClient.get<IProjectInvoice[], Record<string, string>>(`${Urls.Projects.projects}${projectId}/invoices/`, queryParams)
  },

  getPaginatedProjectInvoices(projectId: string | number, queryParams: Record<string, string>): Promise<IPagination<IProjectInvoice[]>> {
    return HttpClient.get<IPagination<IProjectInvoice[]>, Record<string, string>>(`${Urls.Projects.projects}${projectId}/invoices/`, queryParams)
  },

  getProjectInvoice(projectId: number | string, invoice_id: number | string): Promise<IProjectInvoice> {
    return HttpClient.get<IProjectInvoice, IProjectInvoice>(`${Urls.Projects.projects}${projectId}/invoices/${invoice_id}/`)
  },

  createProjectInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<IProjectInvoice> {
    return HttpClient.post<IProjectInvoice, IProjectInvoice>(`${Urls.Projects.projects}${projectId}/invoices/`, invoice)
  },

  updateProjectInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<IProjectInvoice> {
    return HttpClient.put<IProjectInvoice, IProjectInvoice>(`${Urls.Projects.projects}${projectId}/invoices/`, invoice.id, invoice)
  },

  deleteProjectInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(`${Urls.Projects.projects}${projectId}/invoices/`, invoice.id)
  },

  getPositionPayments(projectId: string | number, queryParams?: Record<string, string>): Promise<IPagination<IPositionPayment[]> | IPositionPayment[]> {
    return HttpClient.get<IPagination<IPositionPayment[]>, Record<string, string>>(`${Urls.Projects.projects}${projectId}/position-payments/`, queryParams)
  },

  /* Scheduled payments */
  getDirectCostInvoices(projectId: string | number, queryParams?: Record<string, string>): Promise<IDirectCostInvoice[]> {
    return HttpClient.get<IDirectCostInvoice[], Record<string, string>>(`${Urls.Projects.projects}${projectId}/direct-cost-invoices/`, queryParams)
  },

  getDirectCostInvoice(projectId: number | string, invoice_id: number | string): Promise<IDirectCostInvoice> {
    return HttpClient.get<IDirectCostInvoice, IDirectCostInvoice>(`${Urls.Projects.projects}${projectId}/direct-cost-invoices/${invoice_id}/`)
  },

  createDirectCostInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<IDirectCostInvoice> {
    return HttpClient.post<IDirectCostInvoice, IDirectCostInvoice>(`${Urls.Projects.projects}${projectId}/direct-cost-invoices/`, invoice)
  },

  updateDirectCostInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<IDirectCostInvoice> {
    return HttpClient.put<IDirectCostInvoice, IDirectCostInvoice>(`${Urls.Projects.projects}${projectId}/direct-cost-invoices/`, invoice.id, invoice)
  },

  deleteDirectCostInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(`${Urls.Projects.projects}${projectId}/direct-cost-invoices/`, invoice.id)
  },

  getLatestPayments(projectId: number): Promise<IProjectInvoice[]> {
    return HttpClient.get<IProjectInvoice[], null>(`${Urls.Projects.projects}${projectId}/latest-payments`)
  },
}
